export const getVimeoLiveStreamEmbedURL = (videoId, unlistedHash) => `https://vimeo.com/event/${videoId}/embed${unlistedHash ? `/${unlistedHash}` : ''}`;
